'use strict';

/**
 *  Load modules
 */
import burgerMenu from './modules/burgerMenu';
import popupForm from './modules/popupForm';
import featuredSlider from './modules/featuredSlider.js'
import filter from './modules/filter.js'
import blocksViewport from './modules/blocksViewport.js'
import peopleDeeplink from './modules/peopleDeeplink.js'
import peopleSlider from './modules/peopleSlider.js'
import shareSocial from './modules/shareSocial.js';


function dismissMessageBar(){

	const messageBar = document.querySelector('.message-bar');
	if (messageBar) {
		const dismissButton = messageBar.querySelector('.close');
		dismissButton.addEventListener('click', function () {
			// remove the element from the DOM
			messageBar.style.transition = 'opacity 0.5s';
			messageBar.style.opacity = '0';
			setTimeout(() => messageBar.remove(), 500);
		});
	}

}	// end dismissMessageBar()

function printPage() {

	// if a link with the class "print-link" is clicked, print the page
	const printLink = document.querySelector('.print-link');
	if (printLink) {
		printLink.addEventListener('click', function (evt) {
			evt.preventDefault();
			window.print();
		});
	}

}

document.addEventListener('DOMContentLoaded', function () {
    popupForm();
    shareSocial();

	dismissMessageBar();
	printPage();
});
